export const DNS_VALIDATOR = /[a-zA-Z0-9-_]{1,61}(?:\.[a-zA-Z]{2,})+/g;
export const EMAIL_VALIDATOR = /^[a-z0-9.]{1,64}@[a-z0-9.-]{1,64}(?<![.-])$/i;

export const matchFirstDNS = function (str) {
    if (typeof str !== 'string' && !DNS_VALIDATOR.test(str)) {
        return null;
    }
    return str.match(DNS_VALIDATOR).shift();
}